export { default as getBodyForHiddenEntity } from './getBodyForHiddenEntity'
